import { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../api/services';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authApi.me()
        .then((res) => setUser(res.data.user))
        .catch(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await authApi.login({ email, password });
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const hasRole = (role) => user?.roles?.includes(role) || user?.roles?.includes('super_admin');
  const hasPermission = (perm) => user?.permissions?.includes(perm) || user?.roles?.includes('super_admin');
  const isSuperAdmin = () => user?.roles?.includes('super_admin');
  const isDispatchAdmin = () => hasRole('dispatch_admin');
  const isDispatchUser = () => hasRole('dispatch_user');
  const isOps = () => hasRole('ops_team');
  const isAdmin = () => isSuperAdmin() || isDispatchAdmin();

  return (
    <AuthContext.Provider value={{
      user, loading, login, logout,
      hasRole, hasPermission,
      isSuperAdmin, isDispatchAdmin, isDispatchUser, isOps, isAdmin,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
